const KEY = 'krazy-wordz-super-admin';

// The super admin tools are unlocked by opening any page with ?admin=<SUPER_ADMIN_SECRET>. The
// server checks the secret. It is kept for the browser tab (so it survives rematches) and removed
// from the address bar, so it doesn't end up in copied game links.
export const captureSuperAdminSecret = (history) => {
    const params = new URLSearchParams(window.location.search);
    const secret = params.get('admin');

    if (secret === null) {
        return;
    }

    try {
        window.sessionStorage.setItem(KEY, secret);
    } catch (error) {
        // sessionStorage is not supported when browsing privately
    }

    params.delete('admin');

    const search = params.toString();

    history.replace(`${window.location.pathname}${search ? `?${search}` : ''}${window.location.hash}`);
};

export const getSuperAdminSecret = () => {
    try {
        return window.sessionStorage.getItem(KEY) || undefined;
    } catch (error) {
        return undefined;
    }
};
